import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        signImg: [],
        signImgMarket: [],
        singlePrice:''
    },
    mutations: { 
        pushImgUrl (state,newImgUrl) {
            state.signImg.push(newImgUrl)
        },
        pushImgUrlMarket (state,newImgUrl) {
            state.signImgMarket.push(newImgUrl)
        },
        changImgUrl (state,newImgUrl) {
            let arryLast = state.signImg.length - 1
            state.signImg[arryLast].imgUrl = newImgUrl
        },
        changImgUrlMarket (state,newImgUrl) {
            let arryLast = state.signImgMarket.length - 1
            state.signImgMarket[arryLast].imgUrl = newImgUrl
        },
        isSignedTime (state,isTime) {
            let arryLast = state.signImg.length-1
            state.signImg[arryLast].signTime = isTime
        },
        isSignedTimeMarket (state,isTime) {
            let arryLast = state.signImgMarket.length-1
            state.signImgMarket[arryLast].signTime = isTime
        }
        
    },
    modules: {
        user,
        permission
    },
    getters
})

export default store
